/**
 * Pill Tabs JavaScript
 *
 * This file defines Pill Tabs
 * behavior.
 */

/**
 * Import dependencies and globally-available functions
 */
import onReady from '../../../components/util/onReady';
import debounce from '../../../components/util/debounce';

const tabs = window.aquaminTabs;

/**
 * Set up tabs for inner accordions
 */
tabs('pill-tabs', {
	expandFirstTab: true,
	oneAlwaysOpen: true,
	selectors: {
		wrap: '.js-pill-tabs',
		toggles: '.js-pill-tabs-button',
		content: '.js-pill-tabs-content',
	},
});

/**
 * Set up tab navigation animations
 */
document.querySelectorAll('.js-pill-tabs')?.forEach((tab) => {
	// grab the dom nodes
	const buttons = tab.querySelectorAll('.js-pill-tabs-button');
	const pill = tab.querySelector('.js-pill-tabs-pill');
	// move the pill to a button's position
	const movePill = (button) => {
		pill.style.setProperty('--w', `${button.offsetWidth}px`);
		pill.style.setProperty('--x', `${button.offsetLeft}px`);
	};
	// trigger move on click of a tab button
	buttons?.forEach((button) => {
		button.addEventListener('click', () => {
			movePill(button);
		});
	});
	// trigger move on page ready
	onReady(() => movePill(buttons[0]));
	// trigger move on window load again (seems to have a hard time on the first try... sometimes)
	window.addEventListener('load', () => movePill(buttons[0]));
	// trigger again (throttled for performance) on resize
	window.addEventListener(
		'resize',
		debounce(() => {
			const curButton = [...buttons].find(
				(button) => button.getAttribute('aria-selected') === 'true'
			);
			movePill(curButton);
		}, 300)
	);
});
